module.exports = __webpack_public_path__ + "img/bulk-add-icon.aaf1f6a7.svg";